import { Box, SxProps } from '@mui/material';

import { getTheme } from '@sh4res/bo-common/theme';
import { isBoExternal, isDevEnv, isStgEnv } from '@sh4res/bo-common/utils/env';

export const EnvIndicator = () => {
  // Show BO prefix only for normal BO (not BO External) in Axa environments
  const shouldShowBoPrefix = !isBoExternal() && getTheme() === 'axa';

  // Don't show indicator if not in dev/staging environments and not showing BO prefix
  if (!isDevEnv() && !isStgEnv() && !shouldShowBoPrefix) {
    return null;
  }

  const getDisplayText = (): string => {
    const prefix = shouldShowBoPrefix ? 'BO' : '';

    if (isDevEnv()) {
      return prefix ? `${prefix} DEV` : 'DEV';
    }
    if (isStgEnv()) {
      return prefix ? `${prefix} STG` : 'STG';
    }
    // Local / Production
    return prefix || '';
  };

  const getColor = (): string => {
    if (isDevEnv()) {
      return getTheme() === 'axa' ? '#00008F' : 'lawngreen';
    }
    if (isStgEnv()) {
      return 'orange';
    }
    // Local / Production
    return getTheme() === 'axa' ? '#00008F' : 'white';
  };

  const text = getDisplayText();
  const color = getColor();

  if (!text) {
    return null;
  }

  const position: SxProps = {
    color,
    position: 'fixed',
    top: '21px',
    left: '120px',
    width: '120px',
    textAlign: 'right',
    paddingRight: '16px',
    fontWeight: '600',
    fontSize: 'medium',
  };

  return <Box sx={position}>{text}</Box>;
};
